import axios from 'axios'

//const headers = {
//    'Content-Type': 'application/json',
//    'Authorization': 'Bearer ejaJsC9',
//}
export const HTTP_REQ = axios.create({
    baseURL: `https://nite-apigateway.herokuapp.com`,
    headers: {
        //Authorization: 'Bearer {token}',
        'Content-Type': 'application/json'
    }
}

)

/**
 * Sets the Authorization's header token 
 * @param {string} token - the JWT token 
 */
export function set_token(token){
    HTTP_REQ.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}


/**
 * @function manager_get
 *
 * Obtains the manager's data
 * @returns {object} manager data
 */
export const manager_get = () => HTTP_REQ.get('/users/manager');



/**
 * @function manager_reset_password
 *
 * Obtains the manager's data
 * @returns {object} Email Sent
 * @param {string }_email - the email to be sent the password
 */
export const manager_reset_password = (_email) => HTTP_REQ.get('/users/manager/sendMail',  { params: { email: _email } });


/** 
 * @function manager_update_email
 * 
 * Updates the manager's email
 * @example data = { "email": "bazinga.2020.2021(at)gmail.com" }
 * @param {object} data - the manager date with email
 * @returns {Promise<object>} Promise 
 */
export const manager_update_email = (data) => HTTP_REQ.put('/users/manager/email', data)



/**
 * @function manager_sign_up
 * 
 * Signs up a manager
 * @example data  = { "address": "81003 Annamark Hill", "birth": "2007-05-06", "email": "bazinga.2020.2021(at)gmail.com", "establishment": "BA", "name": "Fidelia Hyett", "password": "123admin", "phone": "919999999" }
 * @param {object} data - the to be signed up manager's data
 * @returns {Promise<object>} Promise 
 */
export const manager_sign_up = (data) => HTTP_REQ.post('/users/manager', data)

/**
 * @function manager_delete
 *
 * Deletes the nightclub's manager
 * @returns {Promise<object>} Promise
 */
export const manager_delete = () => HTTP_REQ.delete(`/users/manager`)

/**
 * @function manager_login
 * 
 * Logs in a manager 
 * @example data = { "email": "bazinga.2020.2021(at)gmail.com", "password": "123admin" }
 * @param {object} data - the manager's login credentials data
 * @returns {Promise<object>} Promise 
 */
export const manager_login = (data) => HTTP_REQ.post('/users/manager/login', data)




/**
 * @function manager_update
 * 
 * Updates the manager's data 
 * @example data = { "address": "81003 Annamark Hill", "birth": "2007-05-06", "establishment": "BA", "name": "Fidelia Hyett", "phone": "919999999" }
 * @param {object} data - the to be updated manager's data
 * @returns {Promise<object>} Promise 
 */
export const manager_update = (data) => HTTP_REQ.put('/users/manager', data)




/**
 * @function manager_update_password
 * 
 * Updates the manager's password
 * @example data = { "newPassword": "123admin", "oldPassword": "1234admin" }
 * @param {object} data - the to be updated manager's password data
 * @returns {Promise<object>} Promise 
 */
export const manager_update_password = (data) => HTTP_REQ.put('/users/manager/password', data)


/**
 * @function manager_get_categories
 * 
 * Obtains all the night club's product categories
 * @returns {Promise<object[]>} Promise 
 * 
 */
export const manager_get_categories = () => HTTP_REQ.get('/nightClub/categories')


/**
 * @function manager_create_employee
 * 
 * Creates a night club's employee
 * @example data = { "address": "93 Northport Trail", "birth": "1987-03-29", "email": "bazinga999999999(at)gmail.com", "establishment": "BA", "name": "Gaston Parkyns", "phone": "919999999", "job": "Sound Engineer" }
 * @param {object} data - the to be created employee info
 * @returns {Promise<object>} Promise 
 */
export const manager_create_employee = (data) => HTTP_REQ.post('/users/employee', data)


/**
 * @function manager_update_employee
 * 
 * Updates a night club's employee
 * @example data = { "address": "93 Northport Trail", "birth": "1987-03-29", "email": "bazinga999999999(at)gmail.com", "establishment": "BA", "name": "Gaston Parkyns", "phone": "910000000", "job": "Sound Engineer" }
 * @param {string} id - the to be updated employee id
 * @param {object} data - the to be updated employee data
 * @returns {Promise<object>} Promise 
 */
export const manager_update_employee = (id, data) => HTTP_REQ.put(`/users/manager/employee/${id}`, data)

/**
 * @function manager_delete_employee
 * 
 * Deletes a nightclub's employee
 * @param {string} id - the to be deleted employee id
 * @returns {Promise<object>} Promise 
 */
export const manager_delete_employee = (id) => HTTP_REQ.delete(`/users/manager/employee/${id}`)


/**
 * @function manager_get_all_employees
 * 
 * Obtains all the nightclub's employees
 * @returns {Promise<object[]>} Promise 
 * 
 */
export const manager_get_all_employees = () => HTTP_REQ.get('/users/manager/employees')



/**
 * @function manager_create_product
 * 
 * Creates a nightclub's product
 * @example data = { "product_category": "Cocktails", "product_name": "Sex on the beach", "product_price": 8.41 }
 * @param {object} data - the to be created product data
 * @returns {Promise<object>} Promise 
 */
export const manager_create_product = (data) => HTTP_REQ.post('/nightClub/products', data)


/**
 * @function manager_update_product
 * 
 * Updates a nightclub's product
 * @example data = { "product_category": "Cocktails", "product_name": "Sex on the beach", "product_price": 100.41 }
 * @param {string} id - the to be updated product id
 * @param {object} data - the to be updated product data
 * @returns {Promise<object>} Promise 
 */
export const manager_update_product = (id, data) => HTTP_REQ.put(`/nightClub/products/${id}`, data)


/**
 * @function manager_delete_product
 * 
 * Deletes a nightclub's product
 * @param {string} id - the to be deleted product id
 * @returns {Promise<object>} Promise 
 */
export const manager_delete_product = (id) => HTTP_REQ.delete(`/nightClub/products/${id}`)

// Manager get all products

/**
 * @function manager_get_all_products
 * 
 * Obtains all the nightclub's products 
 * @returns {Promise<object[]>} Promise 
 * 
 */
export const manager_get_all_products = () => HTTP_REQ.get('/nightClub/products')



/**
 * @function manager_create_menu
 * 
 * Creates a nightclub's menu
 * @example data = { "menu_description": "Lorem Ipsum", "menu_name": "Ladies Night", "menu_status": false, "menu_products": [ { "product_name": "Bread - Pain Au Liat X12", "product_price": 9.2, "product_category": "Spirits", "product_id": "5fc2ecd8fc13ae50c00002e4" }, { "product_name": "Lamb - Whole, Frozen", "product_price": 5.86, "product_category": "Spirits", "product_id": "5fc2ecd8fc13ae50c000039b" } ] }
 * @param {object} data - the to be created menu data
 * @returns {Promise<object>} Promise 
 */
export const manager_create_menu = (data) => HTTP_REQ.post('/nightClub/menus', data)



/**
 * @function manager_update_menu
 * 
 * Updates a nightclub's menu
 * @example data = { "menu_description": "Lorem Ipsum", "menu_name": "Saturday Night Fever", "menu_status": false, "menu_products": [ { "product_name": "Bread - Pain Au Liat X12", "product_price": 9.2, "product_category": "Spirits", "product_id": "5fc2ecd8fc13ae50c00002e4" }, { "product_name": "Lamb - Whole, Frozen", "product_price": 5.86, "product_category": "Spirits", "product_id": "5fc2ecd8fc13ae50c000039b" } ] }
 * @param {string} id - the to be updated menu id
 * @param {object} data - the to be updated menu data
 * @returns {Promise<object>} Promise 
 */
export const manager_update_menu = (id, data) => HTTP_REQ.put(`/nightClub/menus/${id}`, data)


/**
 * @function manager_update_menu
 *
 * Updates a nightclub's menu status
 * @param {string} id - the to be updated menu id
 * @returns {Promise<object>} Promise
 */
export const manager_update_menu_status = (id) => HTTP_REQ.put(`/nightClub/menus/active`, {"id": id})



/**
 * @function manager_delete_menu
 * 
 * Deletes a nightclub's menu 
 * @param {string} id - the to be deleted menu id
 * @returns {Promise<object>} Promise 
 */
export const manager_delete_menu = (id) => HTTP_REQ.delete(`/nightClub/menus/${id}`)


/** 
 * @function manager_get_all_menus 
 * 
 * Obtains all the nightclub's menus
 * @returns {Promise<object[]>} Promise 
 */
export const manager_get_all_menus = () => HTTP_REQ.get('/nightClub/menus')


/** 
 * @function manager_create_pr
 * 
 * Creates a nightclub's public relations
 * @example data = { "pr_email": "atyrrell9999999990(at)gmail.com", "pr_fullname": "Angelita Tyrrell", "pr_phone": "917777777", "pr_shortcode": "atyrrell083" }
 * 
 * @param {object} data - the to be created PR data
 * @returns {Promise<object>} Promise 
 */
export const manager_create_pr = (data) => HTTP_REQ.post('/nightClub/public-relations', data)


/** 
 * @function manager_delete_pr
 * 
 * Deletes a nightclub's public relations
 * @param {string} id - the to be deleted PR id
 * @returns {Promise<object>} Promise 
 */
export const manager_delete_pr = (id) => HTTP_REQ.delete(`/nightClub/public-relations/${id}`)


/** 
 * @function manager_update_pr
 * 
 * Updates a nightclub's public relations
 * @example date = { "pr_email": "atyrrell0999999999(at)gmail.com", "pr_fullname": "Angelita Tyrrell", "pr_phone": "917777777", "pr_shortcode": "atyrrell083" }
 * @param {string} id - the to be updated PR id
 * @param {object} data - the to be updated PR data
 * @returns {Promise<object>} Promise 
 */
export const manager_update_pr = (id, data) => HTTP_REQ.put(`/nightClub/public-relations/${id}`, data)

// Manager get all PR
/** 
 * @function manager_get_all_prs
 * 
 * Obtains all the nightclub's public relations
 * @returns {Promise<object[]>} Promise 
 */
export const manager_get_all_prs = () => HTTP_REQ.get('/nightClub/public-relations')

/**
 * @function manager_get_prs_stats
 *
 * Obtains the nightclub's public relations stats per date
 * @param {string }_date - date to use as a filter
 * @returns {Promise<object[]>} Promise 
 */
export const manager_get_prs_stats = (_date) => HTTP_REQ.get(`/nightClub/public-relations/stats`,  { params: { date: _date } });

/**
 * https://auralinna.blog/post/2019/global-http-request-and-response-handling-with-the-axios-interceptor/
 * https://gist.github.com/fgilio/230ccd514e9381fafa51608fcf137253
 * https://www.intricatecloud.io/2020/03/how-to-handle-api-errors-in-your-web-app-using-axios/
 * https://medium.com/javascript-in-plain-english/all-in-one-tutorial-on-how-to-create-the-authentication-part-of-your-react-app-2530e7435629
 * https://medium.com/swlh/handling-access-and-refresh-tokens-using-axios-interceptors-3970b601a5da
 * https://www.reddit.com/r/vuejs/comments/84wufw/vuejs_and_authentication_with_jwt_and_refresh/
 * 
 * https://jasonwatmore.com/post/2018/07/06/vue-vuex-jwt-authentication-tutorial-example
 * https://kapeli.com/cheat_sheets/Axios.docset/Contents/Resources/Documents/index 
 * 
 */



/************************** */



/**
 * @example await axiosInstance.get('/v2/api-endpoint', { handlerEnabled: false })
 * @param {object} config 
 */
const isHandlerEnabled = (config={}) => {
    return !(Object.prototype.hasOwnProperty.call(config, 'handlerEnabled') && !config.handlerEnabled)
  }


  const requestHandler = (request) => {
    if (isHandlerEnabled(request)) {
      // Modify request here
      //request.headers['X-CodePen'] = 'https://codepen.io/teroauralinna/full/vPvKWe'
    }
    return request
  }

  HTTP_REQ.interceptors.request.use(
    request => requestHandler(request)
  )

  const errorHandler = (error) => {
    if (isHandlerEnabled(error.config)) {
      // Handle errors
    }
    return Promise.reject({ ...error })
  }
  
  const successHandler = (response) => {
    if (isHandlerEnabled(response.config)) {
      // Handle responses
    }
    return response
  }

  HTTP_REQ.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
  )

  